import { atom } from "jotai";

export interface OptimizationBatch {
  batchId: string;
  done: number;
  total: number;
}

/** Null when no batch is in progress; set to progress data while routes are recalculating. */
export const optimizationBatchAtom = atom<OptimizationBatch | null>(null);
